import { Box, Dialog, DialogContent, DialogProps, DialogTitle } from '@mui/material'
import { CatalogProductType } from '../enums'
import { useTranslation } from 'react-i18next'
import CatalogProductForm from './CatalogProductForm'
import { CatalogProduct } from '../types'

export interface CatalogProductCreateDialogProps extends Omit<DialogProps, 'children' | 'onClose'> {
  type?: CatalogProductType
  afterCreate?: (catalogProduct: CatalogProduct) => void
  onClose?: () => void
}

export default function CatalogProductCreateDialog({
  type,
  afterCreate,
  onClose,
  open,
  ...props
}: CatalogProductCreateDialogProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * Handle the "after submit" event.
   */
  function handleAfterSubmit(catalogProduct: CatalogProduct) {
    afterCreate?.(catalogProduct)
    onClose?.()
  }

  /**
   * Handle the "cancel" event.
   */
  function handleCancel() {
    onClose?.()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth {...props}>
      <DialogTitle>{t('newCatalogProduct')}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <CatalogProductForm type={type} afterSubmit={handleAfterSubmit} onCancel={handleCancel} />
        </Box>
      </DialogContent>
    </Dialog>
  )
}
